import React, {
  useState,
  useEffect,
  useMemo,
} from 'react';
import { Button } from '@saleshandy/design-system';
import Select from '../../../../../../../../../../shared/design-system/components/select';
import SettingsText from '../settings-text';
import { AssignPhoneNumberSettingsProps } from './types';
import { getIsRequestPending } from '../../../../../../../../../../shared/utils';

const AssignPhoneNumberSettings: React.FC<AssignPhoneNumberSettingsProps> = ({
  activeNumberSettings,
  teamMembersList,
  getTeamMembersListRequest,
  onSave,
  assignPhoneNumberRequestStatus,
}) => {
  const [selectedTeamMemberId, setSelectedTeamMemberId] = useState<
    number | null
  >(null);

  // Fetch team members when component mounts
  useEffect(() => {
    getTeamMembersListRequest();
  }, [getTeamMembersListRequest]);

  // Initialize selected team member from active number settings
  useEffect(() => {
    if (activeNumberSettings?.assignedUser) {
      setSelectedTeamMemberId(activeNumberSettings.assignedUser.id);
    }
  }, [activeNumberSettings]);

  // Map team members to options for Select component
  const teamMemberOptions = useMemo(() => {
    if (!teamMembersList || teamMembersList.length === 0) {
      return [];
    }
    return teamMembersList.map((member) => ({
      key: String(member?.id),
      value: member?.name || member?.email || '',
    }));
  }, [teamMembersList]);

  const handleSave = () => {
    if (selectedTeamMemberId && activeNumberSettings?.id) {
      onSave(activeNumberSettings.id, selectedTeamMemberId);
    }
  };

  return (
    <div
      id="assign-number"
      className="settings-wrapper assign-phone-number-settings"
    >
      <SettingsText
        title="Assign Phone Number"
        description="Assign this number to your team member or yourself"
      />
      <div className="assign-phone-number-settings__select-container">
        <Select<{ key: string; value: string }>
          className="assign-phone-number-settings__select"
          options={teamMemberOptions}
          selectedOptionKey={
            selectedTeamMemberId ? String(selectedTeamMemberId) : null
          }
          selectedOptionRenderer={([option]) => (
            <span>{option?.value || 'Select Team Member'}</span>
          )}
          optionRenderer={(option) => <span>{option?.value}</span>}
          onChange={([option]) => {
            if (option) {
              setSelectedTeamMemberId(Number(option?.key));
            }
          }}
          placeholder="Select Team Member"
          showSearch
          searchPlaceholder="Search team member"
          optionFilterProp="value"
          autoFocusSearch={true}
        />
      </div>
      <div className="assign-phone-number-settings__actions">
        <Button
          variant="primary"
          onClick={handleSave}
          className="settings-wrapper__save-btn assign-phone-number-settings__save-btn"
          disabled={
            selectedTeamMemberId === activeNumberSettings?.assignedUser?.id ||
            getIsRequestPending(assignPhoneNumberRequestStatus)
          }
          isLoading={getIsRequestPending(assignPhoneNumberRequestStatus)}
          loadingText="Save"
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default AssignPhoneNumberSettings;
